function TestSuite (options) {
  options = options || {};
  this.allTestsComplete = false;
  this.stopOnFailure = false;
  this.running = false;
  this.queue = [];
  this.logger = options.logger || console;
  this.onNext = options.onNext || angular.noop;

  this.hasError = false;
  this.results = [];
}

TestSuite.prototype.addTest = function(test) {
  this.queue.push(test);
};

TestSuite.prototype.start = function() {
  var that = this;

  return new Promise(function(resolve, reject) {
    return that.runNextTest().then(function() {
      if (that.hasError) {
        var error = new Error('A test failure occurred');
        error.details = that.results;
        return reject(error);
      }
      return resolve(that.results);
    }, function(err) {
      err.details = that.results;
      return reject(err);
    });
  });
};

TestSuite.prototype.runNextTest = function() {
  this.running = true;
  var test = this.queue.shift();

  if (!test) {
    this.running = false;
    return Promise.resolve();
  }

  this.activeTest = test;
  this.onNext(this.activeTest);

  this.logger.log('Starting ' + test.name);

  var next = function(err) {
    test.running = false;
    test.destroy();
    if (err) {
      this.hasError = true;
      if (this.stopOnFailure) {
        return Promise.reject(err);
      }
    }

    return this.runNextTest();
  }.bind(this);

  var that = this;
  return test.start().then(function(results) {
    that.results.push({
      status: 'passed',
      name: test.name,
      results: results,
    });
    return next();
  }, function(err) {
    that.hasError = true;
    var errInfo = {
      status: 'failed',
      name: test.name,
      message: err.message,
      details: err.details
    };
    that.results.push(errInfo);
    that.logger.error('Test failure', errInfo, test);
    return next(err);
  });
};

TestSuite.prototype.stopAllTests = function() {
  this.activeTest.destroy();
  this.queue = [];
};

module.exports = TestSuite;



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/troubleshoot/test-suite.js
 ** module id = 412
 ** module chunks = 0
 **/